import React from 'react'
import { Logo2, SendIcon } from '../Constant/Index'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <>
            <footer className="footer">
                <div className="container">
                    <div className="footer-start">
                        <div className="row pb-3">
                            <div className="col-xl-4 col-lg-4 mt-5 mt-xl-0">
                                <div className="footer-single-column  primary-text">
                                    <div className="footer-text">
                                        <figure className="footer-logo">
                                            <Link to=""><img src={Logo2} alt="" className='the-img' /></Link>
                                        </figure>
                                        <p className="text">Lorem ipsum dolor sit amet, coctetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. minim veniam.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-8 mt-5 mt-xl-0">
                                <div className="footer-single-column">
                                    <div className="quick-link-flex d-flex justify-content-between">
                                        <div className="single-links-columns  primary-text">
                                            <h6 className="xs-heading small">Quick Links</h6>
                                            <ul className="footer-links">
                                                <li className="list-items"><Link className='single-link' to="/">Home</Link></li>
                                                <li className="list-items"><Link className='single-link' to="/aboutus">About Us</Link></li>
                                                <li className="list-items"><Link className='single-link' to="/services">Services</Link></li>
                                                <li className="list-items"><Link className='single-link' to="/tools">Tools</Link></li>
                                                <li className="list-items"><Link className='single-link' to="/news">News</Link></li>
                                                <li className="list-items"><Link className='single-link' to="">Online Tools</Link></li>
                                                <li className="list-items"><Link className='single-link' to="/contact-us">Contact Us</Link></li>
                                            </ul>
                                        </div>
                                        <div className="single-links-columns  primary-text">
                                            <h6 className="xs-heading small">Legal</h6>
                                            <ul className="footer-links">
                                                <li className="list-items"><Link className='single-link' to="/terms-conditions">Terms and Conditions</Link></li>
                                                <li className="list-items"><Link className='single-link' to="/shipping-insurance">Shipper’s Insurance</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 mt-5 mt-xl-0">
                                <div className="footer-single-column primary-text">
                                    <div className="contact-footer">
                                        <h6 className="xs-heading small">Contact us</h6>
                                        <ul className="contact-lis">
                                            <li className='contact-item'><i className="icon fa fa-map-marker"></i><span className='contact-info' >0123 Weslayan St. #4567; Houston, TX 89101</span></li>
                                            <li className='contact-item'><i className="icon fa fa-phone"></i><a className='contact-info' href="tel: +123-456-7890">+123-456-7890</a></li>
                                            <li className='contact-item'><i className="icon fa fa-envelope"></i><a className='contact-info' href="mailto: support@webtransusa.com">support@webtransusa.com</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-xl-3 col-lg-6 mt-5 mt-xl-0">
                                <div className="footer-single-column">
                                    <div className="contact-footer">
                                        <h6 className="xs-heading small primary-text">Newsletter</h6>
                                        <form className="enter-email">
                                            <input type="email" name="" id="" className='form-control ' placeholder='Enter Your email' />
                                            <button type="submit" className='email-submit'><img src={SendIcon} alt="" /></button>
                                        </form>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        <div className="footer-copy-write d-flex justify-content-between align-items-start align-items-lg-center mt-4 ">
                            <p className="text">© 2023 The Web Founders. All Rights Reserved.</p>
                            <ul className='right-social d-flex list-style-none gap-2'>
                                <li><a href=""><i className="fa fa-share-alt"></i></a></li>
                                <li><a href=""><i className="fa fa-twitter"></i></a></li>
                                <li><a href=""><i className="fa fa-youtube-play"></i></a></li>
                                <li><a href=""><i className="fa fa-facebook"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}
export default Footer;